import {takeEvery,put,call} from 'redux-saga/effects';
import { GET_CLIENT_SETTING, ON_INACTIVE_CLIENT } from './actionType';
import { getClientSettingApi, inactiveClientApi } from 'helpers/backend_helper';
import { getClientSettingFail, getClientSettingSuccess, inactiveClientFail, inactiveClientSuccess } from './actions';







function*  onGetClientSetting(){
    try {
       const result = yield call( getClientSettingApi)
        yield put(getClientSettingSuccess(result))
    } catch (error) {
        yield put(getClientSettingFail(error))
    }
}

function*  onInactiveClient({payload:data}){
    try {
        yield call( inactiveClientApi, {des:data})
        const result = yield call( getClientSettingApi)
        yield put(getClientSettingSuccess(result))
    } catch (error) {
        yield put(inactiveClientFail(error))
    }
}

function* saga(){
    yield takeEvery(GET_CLIENT_SETTING,onGetClientSetting)
    yield takeEvery(ON_INACTIVE_CLIENT,onInactiveClient)

}

export default saga;